import React from 'react';
import Wrapper from '../Wrapper';
import LoaderIcon from './LoaderIcon';

const LoadingComponent = ({isLoading, error}) => {
  if (isLoading) {
    return <Wrapper isLoading>
      <LoaderIcon />
    </Wrapper>;
  }

  if (error) {
    return <Wrapper isLoading>
      Wystąpił problem przy ładowaniu strony.
    </Wrapper>;
  }

  return null;
};

export default LoadingComponent;



// WEBPACK FOOTER //
// ./src/components/LoadingComponent/index.js